// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shippingAddressStyles } from "@awc/Overrides/Widgets/CheckoutShipping/ShippingAddress";
import IconLinkAddressInactive from "@awc/XDL/Icons/IconLinkAddressInactive";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { css } from "styled-components";

shippingAddressStyles.selectSavedAddressLink = {
    css: css`
        margin-left: 20px;
    `,
    typographyProps: {
        size: fontConfig.fontSize.small,
        weight: fontConfig.weight.regular,
        css: css`
            line-height: ${fontConfig.lineHeight.singleLineSmall};
        `,
    },
    icon: {
        iconProps: {
            src: IconLinkAddressInactive,
            size: 12,
            css: css`
                svg {
                    height: 13px;
                }
            `,
        },
    },
};
